import { isEmpty } from 'lodash';
import { useMemo, useState } from 'react';
import Scrollbar from 'src/components/Scrollbar';
import { useFormContext } from 'react-hook-form';
import AssignmentsList from './assigments/AssigmentsList';
import { imageFromAttachment } from 'src/utils/formatPhoto';
import { WrappedPatient } from 'src/@nicheaim/fhir-base/wrappers/Patient';
import { getLatitudeAndLongitude } from 'src/sections/crs/common/common-utils';
import { WrapperOrganization } from 'src/@nicheaim/fhir-base/wrappers/Organization';
import { Box, Button, DialogActions, Grid, Stack, Typography } from '@mui/material';
import { GoogleMap, Marker, TransitLayer, useJsApiLoader } from '@react-google-maps/api';

type Props = {
  patient: WrappedPatient | null;
  performerOrganizations: WrapperOrganization[] | null;
  backStep: VoidFunction;
  nextStep: VoidFunction;
  handleCreateOutboundReferral: (data: any) => void;
};

export default function OutboundReferralAssignments({ 
  patient, 
  performerOrganizations, 
  backStep, 
  nextStep 
}: Props) {

  const {
    setValue,
    watch,
  } = useFormContext();

  const { organization } = watch();
  const orgSelected = isEmpty(organization) ? [] : [organization];

  const fileImage = useMemo(() => {
    if(patient){
      return {
        contentType: 'image/png' ,
        data: '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'
      }
    }
  },[patient]);

  const center = {
    lat: Number(getLatitudeAndLongitude(patient?.getPrimaryAddress()).latitude),
    lng: Number(getLatitudeAndLongitude(patient?.getPrimaryAddress()).longitude)
  };

  const containerStyle = {
    width: '400px',
    height: '550px'
  };

  const JsOptions = useMemo<any>(() => ({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',
    libraries: ['places'],
  }), []);
  const { isLoaded } = useJsApiLoader(JsOptions);

  let iw = 70, ih = 94;

  const alphabet = Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ');

  const [selectedOrganization, setSelectedOrganization] = useState<string[]>(orgSelected);

  const handleSelect = (organizationId: string) => {
    setSelectedOrganization([]);
    setValue('organization','');
    setSelectedOrganization((prevSelectedOrganization) => {
      if (!prevSelectedOrganization.includes(organizationId) ) {
        setValue('organization',organizationId);
        return [...prevSelectedOrganization, organizationId];
      } 
      return prevSelectedOrganization;
    });
  };

  return (
    <>
      <Grid container sx={{ p:2 }}>
        <Grid item xs={12}>
          <Typography>Client Address: {patient?.getPrimaryAddressFormatted()}</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Scrollbar sx={{ height: 550, width: 400, mt: 2 }}>
            {performerOrganizations?.map((option, i) => (
              <AssignmentsList 
                key={i} 
                organization={option} 
                index={i} 
                isSelected={selectedOrganization.includes(option.id || '')}
                onSelect={() => handleSelect(option.id || '')}/>
            ))}
          </Scrollbar>
        </Grid>
        <Grid item xs={12} md={6}>
          <Stack spacing={2} sx={{ p: 2 }}>
            {isLoaded ? (
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={14}
              >
                <TransitLayer />
                <Marker
                  position={{ lat: center.lat || 0, lng: center.lng || 0 }}
                  icon={{
                    url: imageFromAttachment(fileImage),
                    anchor: new window.google.maps.Point(iw / 4, ih / 2 - 2),
                    size: new window.google.maps.Size(iw / 1, ih / 1),
                    scaledSize: new window.google.maps.Size(iw / 1.6, ih / 1.6),
                  }}
                  title={`${patient?.getFullName()}`}
                  key={patient?.id}
                  clickable={true}
                />
                {performerOrganizations?.map((option, i) => (
                  <Marker
                    position={{ lat: getLatitudeAndLongitude(option).latitude || 0, 
                                lng: getLatitudeAndLongitude(option).longitude || 0 }}
                    icon={{
                      url: `https://waqi.info/mapicon/${alphabet[i]}.30.png`,
                      anchor: new window.google.maps.Point(iw / 4, ih / 2 - 5),
                      size: new window.google.maps.Size(iw / 2, ih / 2),
                      scaledSize: new window.google.maps.Size(iw / 2, ih / 2),
                    }}
                    key={option.id}
                    clickable={true}
                  />
                ))}
              </GoogleMap>
              ): (<></>)
            }
          </Stack>
        </Grid>
      </Grid>
      <Stack spacing={2} alignItems="center">
        <DialogActions>
          <Box sx={{ flexGrow: 1 }} />
            <Button variant="outlined" color="info" onClick={backStep}>
              Back
            </Button>
            <Button variant="outlined" color="info" onClick={nextStep}>
              Next
            </Button>
        </DialogActions>
      </Stack>
    </>
  );
}